module.exports = __webpack_public_path__ + "fonts/Decimal-Ultra.cb945d4.woff";